export const siteURLConstants = {
  WHO_WE_ARE: 'https://venturemet.com/who-we-are/',
  WHAT_WE_DO: 'https://venturemet.com/what-we-do/',
  WHY_WE_DO_IT: 'https://venturemet.com/why-we-do-it/',
  CONTACT: 'https://venturemet.com/contact/',
  JOIN_OUR_TEAM: 'https://venturemet.com/who-we-are/join-our-team/',
  TERMS_OF_USE: 'https://venturemet.com/terms-and-conditions/',
  PRIVACY_POLICY: 'https://venturemet.com/privacy-policy/',
  CONTACT_EMAIL: 'contact@venturemet.com',
  CONTACT_CALL_US: '2145744100',
  SOCIAL_LINKEDIN: 'https://www.linkedin.com/company/venture-metals/',
  SOCIAL_FACEBOOK: 'https://www.facebook.com/Venturemet',
  SITE_URL: 'https://venturemet.com',
} as const

export const urlConstants = {
  DEFAULT_PATH: '/',
  TICKETS: '/tickets',
  USER_MANAGEMENT: '/user-management',
  CREATE_USER: '/user-management/create-user',
  VIEW_USER_DATA: '/user-management/view-user',
  EDIT_USER_DATA: '/user-management/edit-user',
  VIEW_USER: '/user-management/view-user/:id',
  EDIT_USER: '/user-management/edit-user/:id',
  MANAGE_SETTINGS: '/manage-settings',
  SUPPLIER_CONSUMER_MAPPING: '/supplier-consumer-mapping',
  MANAGE_PERMISSION: '/manage-settings/:id',
  TICKET_DETAILS: '/tickets/:id',
  SUPPORT: '/support',
  NOT_FOUND: '/not-found',
} as const
